// IN REDESING - CHANGE NAME OF THIS SERVICE TO CitationResourcesService

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MarkAsBrokenParams } from '../../../mark-as-broken/mark-as-broken/mark-as-broken-params';
import { EmbeddedMode } from '../../shared/shared/embeded-mode.enum';
import { EntityType } from '../../shared/shared/entity-type.enum';
import { ApiService } from '../../shared/shared/interfaces/api-service';
import { CitationAvailability } from '../shared/citation-availability';

@Injectable({
  providedIn: 'root'
})
export class CitationAvailabilityService implements ApiService<CitationAvailability> {
  
  entityType = EntityType[EntityType.CITATION_AVAILBILITY];

  constructor(private http : HttpClient) {}

  getAll: (args?: string | { [key: string]: string; }) => Observable<CitationAvailability[]>;
  get: (id?: string) => Observable<CitationAvailability>;
  create: (entity: CitationAvailability) => Observable<CitationAvailability>;
  save = (citationAvail : CitationAvailability) : Observable<CitationAvailability> => this.http.post<CitationAvailability>('../rl/avail/citation/content/availability', citationAvail);
  delete: (entity: CitationAvailability) => Observable<void>;  
  markAsBroken = (citationId: string, markAsBrokenParams : MarkAsBrokenParams) : Observable<any> => this.http.post<any>(`../rl/main/${citationId}/markAsBroken`, markAsBrokenParams);


  makeFileReadOnly(availabilityConf){
    
    availabilityConf.embedded = EmbeddedMode.READONLY;
    return this.save(availabilityConf);
  };

  makeFileDownloadable(availabilityConf){
    
    availabilityConf.embedded = EmbeddedMode.TRUE;
    return this.save(availabilityConf);
  };

  toggelVisibility(availabilityConf){
    availabilityConf.hidden= !availabilityConf.hidden;
    return this.save(availabilityConf);
  };
  
  // create: (entity: CitationAvailability) => Observable<CitationAvailability>;
  // save: (entity: CitationAvailability) => Observable<CitationAvailability>;
  // delete: (entity: CitationAvailability) => Observable<void>;
  // getAll: (args?: string | { [key: string]: string; }) => Observable<CitationAvailability[]>;
  // get: (id?: string) => Observable<CitationAvailability>;
  
  // // create = (asgmt: Assignment) : Observable<Assignment> => this.http.post<Assignment>('../rl/assignments', asgmt);

  // // save = (asgmt: Assignment) : Observable<Assignment> => this.http.put<Assignment>('../rl/assignments', asgmt);

  // // create: (entity: CitationAvailability) => Observable<CitationAvailability> => this.http.post<CitationAvailability>('../rl/citation/'+entity.citationId+'/citationAvailability', entity);
  // // save: (entity: CitationAvailability) => Observable<CitationAvailability>;
  // // delete: (entity: CitationAvailability) => Observable<void>;
  
//   var getAvailability = function (item, type, relatedId) {
//     if (!item) {
//         return {};
//     }
//     if (item && item.availabilityConf) {
//         for (var i = 0; i < item.availabilityConf.length; i++) {
//             if (item.availabilityConf[i].type == type && item.availabilityConf[i].relatedId == relatedId) {
//                 return item.availabilityConf[i];
//             }
//         }
//     }
//     return { "citationId": item.id, "type": type, "relatedId": relatedId };
// };
}
